import "./Home.scss";
import icon_campain_1 from "../../../assets/icon-campain-1.jpg";
import icon_campain_2 from "../../../assets/icon-campain-2.jpg";
import icon_campain_3 from "../../../assets/icon-campain-3.jpg";
import ItemCampain from "../../Molecules/ItemCampain/ItemCampain";
import Button from "../../Atoms/Button/Button";
import SummaryGraph from "../../Molecules/SummaryGraph/SummaryGraph";
import InboundGraph from "../../Molecules/InboundGraph/InboundGraph";
import { useModal } from "../../../customHooks/useModal";
import Modal from "../../Organisms/Modal/Modal";
import iconCreateCampains from '../../../assets/iconCreateCampains.svg'
import iconOutbound from '../../../assets/iconOutbound.svg'
import iconInbound from '../../../assets/iconInbound.svg'
import iconInboundForm from '../../../assets/iconInboundForm.svg'
import iconOutboundForm from '../../../assets/iconOutboundForm.svg'
import CampainBox from "../../Molecules/CampainBox/CampainBox";
import CampainsInboundForm from "../../Organisms/CampainsInboundForm/CampainsInboundForm";
import CampainsInboundFormSecond from "../../Organisms/CampainsInboundForm/CampainsInboundFormSecond";
import { useLocation } from "wouter";
import HeaderTitle from "../../Molecules/HeaderTitle/HeaderTitle";
import { useContext, useEffect, useState } from "react";
import MenuContext from "../../../context/MenuContext";

const campains = [
  {
    title: "Gestionar una Campaña",
    icon: icon_campain_1,
    url: "/campaigns/gestionar"
  },
  {
    title: "Gestionar Productos",
    icon: icon_campain_2,
    url: "/productos/gestionar"
  },
  {
    title: "Gestionar Marketing",
    icon: icon_campain_3,
    url: "/dashboard"
  },
]

const Home = () => {
  const [typeCampaing, setTypeCampain] = useState(null)
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const [isOpenModalInbound, openModalInbound, closeModalInbound] = useModal(false)
  const [isOpenModalInboundSecond , openModalInboundSecond, closeModalInboundSecond] = useModal(false)
  const [, setLocation] = useLocation()
  const { isMenuOpen, setIsMenuOpen } = useContext(MenuContext)

  
  useEffect(() => {
    if(isMenuOpen) {
      setIsMenuOpen(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const openFormCampaing = (type) => {
    setTypeCampain(type)
    closeModal()
    openModalInbound()
  }

  return (
    <>
    <div className="nd-grid main-home">
      <HeaderTitle
        headerText="Control de gestión"
        buttonText="Crear una campaña"
        downText="Hola Maria Alejandra ¿Qué deseas hacer?"
        withDivider
        handleClick={() => openModal()}
      />
      <div className="nd-grid o880-grid-3 rows-gap-2 mt-30">
        {campains.map(campain => 
          <ItemCampain key={campain.title} title={campain.title} icon={campain.icon} url={campain.url} />
        )}
        <div className="main-home__item o880-cols-2 box">
          <h3 className="source-20 pb-20 mt-15 ml-15 s-cross-start s-main-start">Resumen de Campañas</h3>
          <SummaryGraph />
        </div>
        <div className="main-home__item o880-cols-1 box">
          <h3 className="source-20 pb-20 mt-15 ml-15 s-cross-start s-main-start">Indicadores Inbound</h3>
          <InboundGraph />
        </div>
      </div>
    </div>

    <Modal 
      isOpenModal={isOpenModal}
      closeModal={closeModal}
      iconModal={iconCreateCampains}
      titleModal="¿Qué tipo de campaña vas a crear?" 
      subTitleModal="Antes de comenzar selecciona un tipo de campaña:"
    >
      <div className="campains mb-15">
        <CampainBox icon={iconInbound} title="Inbound" subtitle="Para campañas de atracción vía redes sociales, email…" handleClick={() => openFormCampaing(1)} />
        <CampainBox icon={iconOutbound} title="Outbound" subtitle="Para campañas de contacto vía llamadas, mensajería SMS…" handleClick={() => openFormCampaing(2)} />
      </div>
      <p className="source-20 mb-20">¿No sabes que campaña necesitas?</p>
      <div className="buttons-container center">
        <Button content="Comienza creando productos" customClass="s-large m-auto" type="primary" clickHandler={() => setLocation('/productos/crear')} />
      </div>
    </Modal>

    {/* Form Inbound */}
    <Modal 
      isOpenModal={isOpenModalInbound}
      closeModal={closeModalInbound}
      iconModal={`${typeCampaing === 1 ? iconInboundForm : iconOutboundForm}`}
      titleModal={`Campaña ${typeCampaing === 1 ? 'Inbound' : 'Outbound'}`}
      subTitleModal="Indica el nombre, objetivos, acciones y canales para esta campaña"
    >
     <CampainsInboundForm typeCampaing={typeCampaing} closeModalInbound={closeModalInbound} openModalInboundSecond={openModalInboundSecond} />
    </Modal>

    {/* Form Inbound second */}
    <Modal 
      isOpenModal={isOpenModalInboundSecond}
      closeModal={closeModalInboundSecond}
      iconModal={`${typeCampaing === 1 ? iconInboundForm : iconOutboundForm}`}
      titleModal={`Campaña ${typeCampaing === 1 ? 'Inbound': 'Outbound'}`}
      subTitleModal="Indica el fecha de inicio, hora y frecuencia para este campaña o si es por cantidad de acciones según los canales seleccionados:"
    >
     <CampainsInboundFormSecond closeModalInboundSecond={closeModalInboundSecond} />
    </Modal>
    </>
  );
};

export default Home;
